module.exports = __webpack_public_path__ + "static/media/2.ed21c5a1.jpg";